async function sha256(str) {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(str));
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
}

export async function getDeviceId() {
  let seed = localStorage.getItem("zs_device_seed");
  if (!seed) {
    seed = crypto.randomUUID();
    localStorage.setItem("zs_device_seed", seed);
  }
  const raw = [
    seed,
    navigator.userAgent,
    navigator.language,
    screen.width + "x" + screen.height,
    Intl.DateTimeFormat().resolvedOptions().timeZone,
    navigator.hardwareConcurrency || "",
  ].join("::");
  return sha256(raw);
}
